import { RCCButton } from "react-common-components";
import styled, { css } from "styled-components";
import { ICalendarFilter, IEventContainer } from "./interface";

const styledColors = [
	"var(--grey)",
	"var(--purple-lighter)",
	"var(--blue)",
	"var(--orange)",
	"var(--green)"
];

export const OverflowSpan = styled.span`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-word;
    white-space: pre-line;
    overflow: hidden;
    font-size: 0.75rem;
    padding: 0 0.3rem;
`;

export const FixedDiv = styled.div<IEventContainer>`
    position: absolute;
    top: 0; 
    left: 0; 
    width: 4px; 
    height: 100%; 
    background:${(props) => styledColors[props.type]};
`;

export const EventContainer = styled.div<IEventContainer>`
    border: 1px solid var(--border-color);
    box-shadow: 0 2px 1px -1px var(--border-color);
    border-radius:5px;

    background-color:${(props) => styledColors[props.type]};
    color: white;
    font-size: 0.83rem;
    display:flex;
    margin-top:1px;
    
    cursor:pointer;

    .content{
        display:flex;
        align-items: center;
        margin: 0.2rem 0;
    }

    .text-wrapper{
        padding:0.3rem 0 0.1rem 0;
        align-items: baseline;
    }
`;

export const CalendarFilterButton = styled(RCCButton)<ICalendarFilter>`
    padding: 2px 8px;
    height:32px;
    margin: 5px 2px;
    ${(props) => props.isActive && css`filter: brightness(0.5);`}
`;

export const AgendaContainer = styled.div<IEventContainer>`
    padding:3px 0;
    display:flex;
    align-items:center;
    width: 100%;
    position: relative;
    
    &::after{
        content: "";
        display: flex;
        position: absolute;
        top: -1px;
        left: 0;
        height: calc(100% + 1px);
        width: 0.3rem;
        background: ${(props) => styledColors[props.type]};
    }
`;
